import { apiConfig } from "../apiConfig";


export const forgot_password = async (payload) => {
    try {
        const response = await apiConfig.post(`ForgotPassword`, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const forgot_password_code_check = async (payload) => {
    try {
        const response = await apiConfig.post(`ForgotpassordCodecheck`, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const reset_password = async (payload) => {
    try {
        const response = await apiConfig.post(`resetPassword`, payload);
        return response.data;
    } catch (error) {
        throw error;
    }
};